import React from "react";
import { useParams } from "react-router";
import { Col, Container, Row } from "reactstrap";

import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import CopyToClipboard from "src/components/CopyToClipboard/CopyToClipboard";
import { IconName } from "src/components/Icon/Icon";
import { BASE_API_URL } from "../../../../constants/EnvConstants";
import * as S from "../../../../constants/StringConstants";

interface RouteParams {
  id: string;
}

const AnalyzerLinks: React.FC = () => {
  const { id: proposalIDParam } = useParams<RouteParams>();
  const proposalID = proposalIDParam || "new";
  const url = `${BASE_API_URL}proposals/submissions/html/${proposalID}?type=Analyzer`;

  return (
    <CollapsibleCard title={S.FIVE_CARRIER_HEADER} iconName={IconName.BrokerBuilderQuotes} defaultOpen={true}>
      <Container>
        <Row>
          <Col className="link-row">
            <a className="linkItem" href={url} target="__blank">
              {S.PC_LATEST_ANALYZER_LINK}
            </a>
            <CopyToClipboard textToCopy={url} />
          </Col>
        </Row>

        <Row className="card-separator" />
      </Container>
    </CollapsibleCard>
  );
};

export default AnalyzerLinks;
